export default __webpack_public_path__ + "static/media/attachment.a83295fa.svg";